const revealContent = document.querySelector(".reveal__content");

const searchDropdownMenu = document.querySelector(".search-dropdown-menu");
const closestCitiesMenu = document.querySelector(".closest-cities-menu");

const searchButton = document.querySelector(".search-dropdown");
const searchItems = document.querySelectorAll(".reveal__search-item");

const closestCitiesButton = document.querySelector(".closest-cities");
const closestItems = document.querySelectorAll(".reveal__closest-item");

searchButton.addEventListener("click", () => {
  searchItems.forEach((searchItem) => {
    searchItem.classList.toggle("hidden");
  });

  closestItems.forEach((closestItem) => {
    closestItem.classList.add("hidden");
  });

  if (lang === "ar-AR") {
    if (!closestCitiesMenu.classList.contains("fa-chevron-left")) {
      closestCitiesMenu.classList.toggle("fa-chevron-left");
      closestCitiesMenu.classList.toggle("fa-chevron-down");
    }

    searchDropdownMenu.classList.toggle("fa-chevron-left");
    searchDropdownMenu.classList.toggle("fa-chevron-down");
  } else {
    if (!closestCitiesMenu.classList.contains("fa-chevron-right")) {
      closestCitiesMenu.classList.toggle("fa-chevron-right");
      closestCitiesMenu.classList.toggle("fa-chevron-down");
    }

    searchDropdownMenu.classList.toggle("fa-chevron-right");
    searchDropdownMenu.classList.toggle("fa-chevron-down");
  }
});

closestCitiesButton.addEventListener("click", () => {
  closestItems.forEach((closestItem) => {
    closestItem.classList.toggle("hidden");
  });
  searchItems.forEach((searchItem) => {
    searchItem.classList.add("hidden");
  });

  if (lang === "ar-AR") {
    if (!searchDropdownMenu.classList.contains("fa-chevron-left")) {
      searchDropdownMenu.classList.toggle("fa-chevron-left");
      searchDropdownMenu.classList.toggle("fa-chevron-down");
    }

    closestCitiesMenu.classList.toggle("fa-chevron-left");
    closestCitiesMenu.classList.toggle("fa-chevron-down");
  } else {
    if (!searchDropdownMenu.classList.contains("fa-chevron-right")) {
      searchDropdownMenu.classList.toggle("fa-chevron-right");
      searchDropdownMenu.classList.toggle("fa-chevron-down");
    }

    closestCitiesMenu.classList.toggle("fa-chevron-right");
    closestCitiesMenu.classList.toggle("fa-chevron-down");
  }
});
